/**
 * Resize presets API - categories and subcategories for dashboard and resize tool
 * Endpoint: GET /api/resize-presets
 */
import apiClient from "../client";

/**
 * @param {Object} [options]
 * @param {number[]} [options.categoryIds] - Include only these resize_category ids
 * @param {number[]} [options.excludeCategoryIds] - Omit these resize_category ids
 * @param {boolean} [options.dashboardOnly] - Only presets flagged for dashboard hero row
 * @param {string[]} [options.brandSlugs] - Filter by resize_brand slugs (e.g. swiggy)
 * @param {number[]} [options.brandCategoryIds] - Filter by brand.category_id (same as resize_category ids)
 * @returns {Promise<{ success: boolean, data: Array, total: number }>}
 */
export const getResizePresets = async (options = {}) => {
  const params = {};
  const {
    categoryIds,
    excludeCategoryIds,
    dashboardOnly,
    brandSlugs,
    brandCategoryIds,
  } = options;
  if (Array.isArray(categoryIds) && categoryIds.length) {
    params.category_ids = categoryIds.join(",");
  }
  if (Array.isArray(excludeCategoryIds) && excludeCategoryIds.length) {
    params.exclude_category_ids = excludeCategoryIds.join(",");
  }
  if (dashboardOnly) {
    params.dashboard_only = true;
  }
  if (Array.isArray(brandSlugs) && brandSlugs.length) {
    params.brand_slugs = brandSlugs.join(",");
  }
  if (Array.isArray(brandCategoryIds) && brandCategoryIds.length) {
    params.brand_category_ids = brandCategoryIds.join(",");
  }
  const response = await apiClient.get("/api/resize-presets", { params });
  return response.data;
};

/**
 * Get resize presets paginated by category (Phase 2 lazy loading)
 * @param {number} page - Page number (1-based)
 * @param {number} perPage - Categories per page
 * @param {Object} [options] - Same filters as getResizePresets
 * @returns {Promise<{ success: boolean, data: Array, total: number }>}
 */
export const getResizePresetsPaginated = async (page = 1, perPage = 10, options = {}) => {
  const params = { page, per_page: perPage };
  const { categoryIds, excludeCategoryIds } = options;
  if (Array.isArray(categoryIds) && categoryIds.length) {
    params.category_ids = categoryIds.join(",");
  }
  if (Array.isArray(excludeCategoryIds) && excludeCategoryIds.length) {
    params.exclude_category_ids = excludeCategoryIds.join(",");
  }
  const response = await apiClient.get("/api/resize-presets", { params });
  return response.data;
};
